/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listSupportArticles} from '../api'

export const useMutationListSupportArticles = createReactQueryMutationHook('listSupportArticles', listSupportArticles)
